export default angular.module('gg-switch', [])
  .directive('ggSwitch', function () {
    return {
      replace: true,
      restrict: 'E',
      scope: {
        name: '@',
        options: '=?',
        ngModel: '=',
        ngChange: '&',
        ngDisabled: '='
      },
      template: `<div class="c-switch {{singleClasses}}">
        <input ng-repeat-start="(key, option) in options"
          type="radio"
          id="{{(name || 'switch') + '_'+ option.value + '_' + randomId}}"
          class="c-switch__input"
          tabindex="0"
          ng-value="option.value"
          ng-model="$parent.ngModel"
          ng-change="ngChange()"
          ng-disabled="ngDisabled">
        <label ng-repeat-end=""
          for="{{(name || 'switch') + '_'+ option.value + '_' + randomId}}"
          class="c-switch__label {{disabled}}">{{option.name}}</label>
        <div class="c-switch__mark"></div>
      </div>`,
      link: function (scope, elm, attrs) {
        scope.randomId = Math.floor((Math.random() * 10000) + 1);

        if (!scope.options) {
          scope.options = [
            {value: true, name: 'active'},
            {value: false, name: 'inactive'}
          ];
          scope.singleClasses = 'c-switch--single c-switch--single--plain';
        }
      }
    };
  })



/** WEBPACK FOOTER **
 ** ./src/directives/ggSwitch.js
 **/